import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext.js';

function About() {
  const { language, translations } = useContext(LanguageContext);

  return (
    <div className="page about">
      <h1 className='header'>{translations[language].pages.about.h1}</h1>
      <p className='paragraph'>{translations[language].pages.about.p1}</p>
      <p className='paragraph'>{translations[language].pages.about.p2}</p>
    </div>
  );
}

export default About;